import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

import { api } from '../../api';
import { notifyError } from '../Notification';
import AddBusinessModal from './modals/businesses/AddBusinessModal';
import DeleteBusinessModal from './modals/businesses/DeleteBusinessModal';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers } from '../../redux/usersSlice';
import './superAdminBusiness.css';

const SuperAdmin = () => {
    const { items: users, loading, error } = useSelector((state) => state.users);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState('');
    const [selectedFirstName, setSelectedFirstName] = useState('');
    const [selectedBusinessIds, setSelectedBusinessIds] = useState({});
    const [selectedBusinessNames, setSelectedBusinessNames] = useState({});
    const [selectedBusinessId, setSelectedBusinessId] = useState({});
    const [selectedBusinessName, setSelectedBusinessName] = useState({});

    const dispatch = useDispatch();

    // handle add modal close
    const handleAddModalClose = () => setShowAddModal(false);
    // handle add modal show
    const handleAddModalShow = (email, first_name) => {
        setShowAddModal(true);
       setSelectedEmail(email);
       setSelectedFirstName(first_name);
    };
 
    // handle delete modal close
    const handleDeleteModalClose = () => setShowDeleteModal(false);
    // handle delete modal show
    // const handleDeleteModalShow = (email, first_name) => {
    //     setShowDeleteModal(true);
    //     setSelectedEmail(email);
    //     setSelectedFirstName(first_name);
    // };
    const handleDeleteModalShow = (email, firstName, businessId, businessName) => {
      // if businessName is empty, return with notifyError
      if (!businessName) {
        notifyError('Please select a business from assigned businesses to delete');
        return;
      }
      setSelectedEmail(email);
      setSelectedFirstName(firstName);
      setSelectedBusinessId(businessId);
      setSelectedBusinessName(businessName);
      setShowDeleteModal(true);
    };

    const getBusinessName = (id) => {
      const allBusinesses = users.flatMap(user => user.user_businesses);
      const match = allBusinesses.find(b => b.business_id === Number(id));
      return match ? match.business_name : '';
    };
    
  const handleBusinessChange = (event, userEmail, userBusinesses) => {
    const businessId = event.target.value;
    const selectedBusiness = userBusinesses.find(b => b.business_id === parseInt(businessId));
  
    setSelectedBusinessIds(prev => ({ ...prev, [userEmail]: businessId }));
    setSelectedBusinessNames(prev => ({ ...prev, [userEmail]: selectedBusiness?.business_name || '' }));
  };
  
  // Fetch data from backend
  const email = localStorage.getItem('user');
  useEffect(() => {
    if (email) {
      dispatch(fetchUsers(email));
    }
  }, [email, dispatch]);

  useEffect(() => {
    // notify Loading text via Notification component
    if (loading) {
      console.log('Loading...');
    }
    // notify error via Notification component
    if (error) {
      notifyError(error);
    }
  }
  , [loading, error]);



  return (
    <div className='super-admin-container'>
    
      <table className='super-admin-table'>
        <thead className='super-admin-table-header'>
          <tr >
            <th>Name</th>
            <th>Email</th>
            <th>Businesses</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody className='super-admin-table-body'>
          {users?.map((user, index) => (
            <tr key={index}>
              <td>{user.first_name}</td>
              <td>{user.email}</td>
              <td>
                {user.user_businesses.length ? (
               <select
               className='super-admin-select'
               value={selectedBusinessIds[user.email] || ''}
               onChange={(e) => handleBusinessChange(e, user.email, user.user_businesses)}
             >
               <option value="">Assigned businesses</option>
               {user.user_businesses.map((business) => (
                 <option key={business.business_id} value={business.business_id}>
                   {business.business_name}
                 </option>
               ))}
             </select>
             
                ) : (
                  'None'
                )}
              </td>
              <td>
               <div className='super-admin-btns-container'>
                  <button 
                    className='super-admin-btn' 
                    onClick={() => handleAddModalShow(user.email, user.first_name)}>
                     Add
                    </button>
                  <button
                    className='super-admin-btn'
                    onClick={() =>
                      handleDeleteModalShow(
                        user.email,
                        user.first_name,
                        selectedBusinessIds[user.email],
                        selectedBusinessNames[user.email]
                      )
                    }
                  >
                    Delete
                  </button>
               </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* Add modal */}
        <Modal show={showAddModal} onHide={handleAddModalClose}>
            <Modal.Header closeButton>
            <Modal.Title className='add-business-modal-title'>Assign a business to {selectedFirstName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AddBusinessModal email={selectedEmail} onClose={handleAddModalClose}/> 
            </Modal.Body>
        </Modal>
       
        {/* Delete modal */}
        <Modal show={showDeleteModal} onHide={handleDeleteModalClose}>
            <Modal.Header closeButton>
            <Modal.Title>Delete User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DeleteBusinessModal email={selectedEmail} first_name={selectedFirstName} business_id={selectedBusinessId} business_name={selectedBusinessName} onClose={handleDeleteModalClose}/>
            </Modal.Body>
            <Modal.Footer>
            
            </Modal.Footer>
        </Modal>
    </div>
  );
};

export default SuperAdmin;
